<template>
  <a v-if="isMobile && isValidPhoneNo" :href="'tel:' + tel">{{ tel }}</a>
  <a v-else>{{ tel }}</a>
</template>

<script>
import { isMobile as isMobileFunc } from '@utils/client'

export default {
  props: {
    tel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isMobile: false,
    }
  },
  computed: {
    isValidPhoneNo() {
      const pattern = /^0\d{1,4}-\d{1,4}-\d{3,4}$/
      return pattern.test(this.tel)
    },
  },
  mounted() {
    this.isMobile = isMobileFunc()
  },
}
</script>
